import { Tracker as TrackerAdapter } from './interfaces/tracker';
import { TrackerEvent } from './interfaces/tracker-event';

type Config = {
  key: string;
  value: string;
}[];

interface TrackerOptions {
  debug?: boolean;
}

export class Tracker {
  private readonly adapter: TrackerAdapter;
  private readonly options: TrackerOptions;

  constructor(adapter: TrackerAdapter, options: TrackerOptions = { debug: false }) {
    this.adapter = adapter;
    this.options = options;
  }

  public async init(config: Config, bossId: string, userGroup: string) {
    const key = await this.adapter.init(config, bossId, userGroup);
    this.log('🔑', key);
  }

  public async identifyUser(subscriberId: string, bossId: string, partnerId: number) {
    const identity = await this.adapter.identifyUser(subscriberId, bossId, partnerId);
    this.log('👦', identity);
  }

  public track(event: TrackerEvent<object>) {
    try {
      this.adapter.track(event);
      this.log('👉', event.name, event.properties);
    } catch (error) {
      this.log('👎', error);
    }
  }

  public enable() {
    this.adapter.enable();
    this.log('Tracker 👍');
  }

  public disable() {
    this.adapter.disable();
    this.log('Tracker 👎');
  }

  public reset() {
    this.adapter.reset();
    this.log('Tracker ↩️');
  }

  private log(...messages: unknown[]) {
    if (!this.options.debug) {
      return;
    }

    console.log(...messages);
  }
}
